import React from 'react';
import './Legal.css';

export default function Privacy({ navigate }) {
  return (
    <div className="legal-page">
      <div className="page-banner">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Last updated: November 2021</p>
        </div>
      </div>
      <section className="legal-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-intro">
              <p>At HiveeClub, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our platform.</p>
            </div>

            {[
              {
                title: '1. Information We Collect',
                content: `We collect information you provide directly to us, such as when you create an account, make a booking, or contact us for support.\n\nPersonal Information: Name, email address, phone number, date of birth, and profile information.\n\nPayment Information: We collect payment details to process your ticket and table bookings. Payment data is processed securely through our payment providers.\n\nUsage Data: Information about how you use the HiveeClub app, including events attended, tickets purchased, and social interactions.\n\nDevice Information: Device type, operating system, and app version to help us optimise your experience.`
              },
              {
                title: '2. How We Use Your Information',
                content: `We use the information we collect to:\n\n• Process your bookings and payments for tickets and VIP tables\n• Manage your HiveeClub Rewards membership and points\n• Send you event notifications, promotions, and updates\n• Enable social features including group chats and friend connections\n• Improve our platform and develop new features\n• Provide customer support and respond to your enquiries\n• Comply with legal obligations`
              },
              {
                title: '3. Sharing Your Information',
                content: `We do not sell your personal information to third parties. We may share your information with:\n\nVenue Partners: To facilitate your event entry via QR code and manage bookings.\n\nPayment Processors: To securely handle your transactions.\n\nService Providers: Third-party companies that help us operate our platform, such as cloud hosting and analytics services.\n\nLegal Requirements: We may disclose your information if required by law or to protect the rights and safety of HiveeClub and its users.`
              },
              {
                title: '4. Data Security',
                content: `We implement industry-standard security measures to protect your personal information, including:\n\n• Encryption of data in transit and at rest\n• Secure server infrastructure\n• Regular security audits and monitoring\n• Access controls limiting who can view your data\n\nWhile we take every reasonable precaution, no system is completely immune to security risks. We encourage you to use a strong, unique password for your HiveeClub account.`
              },
              {
                title: '5. Your Rights',
                content: `You have the right to:\n\n• Access the personal information we hold about you\n• Correct any inaccurate or incomplete information\n• Request deletion of your personal data, subject to legal requirements\n• Opt out of marketing communications at any time\n• Withdraw consent where processing is based on consent\n\nTo exercise any of these rights, please contact us at info@hivee.app.`
              },
              {
                title: '6. Cookies and Tracking',
                content: `Our app and website use cookies and similar technologies to improve your experience, analyse usage patterns, and deliver relevant content. You can manage cookie preferences through your device settings.`
              },
              {
                title: '7. Children\'s Privacy',
                content: `HiveeClub is not intended for users under 18 years of age. We do not knowingly collect personal information from minors. If you believe a minor has provided us with personal data, please contact us immediately.`
              },
              {
                title: '8. Changes to This Policy',
                content: `We may update this Privacy Policy from time to time. We will notify you of significant changes via the app or email. Continued use of HiveeClub after updates constitutes acceptance of the revised policy.`
              },
              {
                title: '9. Contact Us',
                content: `If you have any questions or concerns about this Privacy Policy, please contact us at:\n\nEmail: info@hivee.app\nHiveeClub — Australia`
              },
            ].map(section => (
              <div key={section.title} className="legal-block">
                <h2>{section.title}</h2>
                {section.content.split('\n').map((line, i) => (
                  <p key={i}>{line || '\u00A0'}</p>
                ))}
              </div>
            ))}

            <div className="legal-footer-cta">
              <p>Questions about your privacy?</p>
              <button className="btn-primary" onClick={() => navigate('contact')}>Contact Us →</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
